<script setup>
import { defineAsyncComponent } from 'vue';

const WrGradientText = defineAsyncComponent(() => import('../global/WrGradientText.vue'));
const WrCardService = defineAsyncComponent(() => import('./WrCardService.vue'));

const services = ref([
  {
    id: 1,
    title: "LARAVEL",
    description: "Open-source object-oriented model-view-controller for PHP.",
    image: "/images/technologies-laravel.webp",
    icon: "/images/cap-laravel.webp",
    link: "/capabilities/laravel-development-company",
  },
  {
    id: 2,
    title: "Vue",
    description: "Easily build astounding single page apps much faster.",
    image: "/images/technologies-vueJS.webp",
    icon: "/images/cap-vue.webp",
    link: "/capabilities/vuejs-development-company",
  },
  {
    id: 3,
    title: "MOR API",
    description:
      "We specialize in providing high-quality and cost-effective MOR API integration services.",
    image: "/images/capability-mor-api-small.webp",
    icon: "/images/logo-kolmisoft.webp",
    link: "/capabilities/mor-api-development-company",
  },
  {
    id: 4,
    title: "FACEBOOK API",
    description: "Get the power of Facebook in your website & application.",
    icon: "/images/cap-facebook.webp",
    link: "/capabilities/facebook-api-integration-company",
  },
  {
    id: 5,
    title: "PAYPAL",
    description: "Now make payments effortlessly with PayPal.",
    icon: "/images/cap-paypal.webp",
    link: "/capabilities/paypal-integration-services",
  },
  {
    id: 6,
    title: "GOOGLE CALENDAR API",
    description:
      "Track your events effortlessly with Google Calendar in your website.",
    icon: "/images/cap-calendar.webp",
    link: "/capabilities/google-calendar-api-integration-services",
  },
  {
    id: 7,
    title: "HIGHCHARTS",
    description:
      "Easily add interactive charts to your website & web application.",
    icon: "/images/cap-highcharts.webp",
    link: "/capabilities/highcharts-api-integration-solutions",
  },
  {
    id: 8,
    title: "SENDGRID",
    description: "Cloud-based SMTP provider that allows you to send email.",
    icon: "/images/cap-sendgrid.webp",
    link: "/capabilities/sendgrid",
  },
  {
    id: 9,
    title: "AJAX",
    description:
      "Now get richer and more responsive user-experience with AJAX.",
    icon: "/images/cap-ajax.webp",
    link: "/capabilities/ajax-development-company",
  },
  {
    id: 10,
    title: "ADONIS",
    description: "MVC Framework for Node to write webapps with less code.",
    icon: "/images/cap-adonis.webp",
    link: "/capabilities/adonisjs-nodejs-development-company",
  },
  {
    id: 11,
    title: "MAILGUN",
    description: "Send, receive & track emails easily with Mailgun.",
    icon: "/images/cap-mailgun.webp",
    link: "/capabilities/mailgun-api-integration-company",
  },
  {
    id: 12,
    title: "STRIPE",
    description:
      "Create subscriptions/accept payments easily in your eCommerce site.",
    icon: "/images/cap-stripesvg.webp",
    link: "/capabilities/stripe-integration-company",
  },
  {
    id: 13,
    title: "SLACK",
    description: "For best one to one & group communications.",
    icon: "/images/cap-slack.webp",
    link: "/capabilities/best-slack-api-integration-company",
  },
  {
    id: 14,
    title: "PUSH NOTIFICATIONS",
    description:
      "Drive traffic by providing valuable updates to your customers instantly.",
    icon: "/images/cap-push.webp",
    link: "/capabilities/push-notifications-integration-company",
  },
  {
    id: 15,
    title: "PUSHER",
    description: "Highly scalable real-time push notification solution.",
    icon: "/images/cap-pusher.webp",
    link: "/capabilities/pusher-integration-company",
  },
  {
    id: 16,
    title: "MONGODB",
    description:
      "For large data transactions and for implementing a scalable model.",
    icon: "/images/cap-mongodb.webp",
    link: "/capabilities/mongodb-development-company",
  },
  {
    id: 17,
    title: "FRESHBOOKS API",
    description:
      "Makes easy your accounting tasks in your website. Effortless & secure.",
    icon: "/images/cap-freshbooks.webp",
    link: "/capabilities/freshbooks-api-integration-services",
  },
  {
    id: 18,
    title: "2CHECKOUT",
    description:
      "Boost online sales. Give buyers worldwide localized payment options.",
    icon: "/images/cap-2checkout.webp",
    link: "/capabilities/2checkout-payment-gateway-integration",
  },
  {
    id: 19,
    title: "LUMEN",
    description: "Great solution for building Laravel based micro-services.",
    icon: "/images/cap-lumen.webp",
    link: "/capabilities/lumen-development-company",
  },
  {
    id: 20,
    title: "TUMBLR API",
    description: "Boost your content marketing with the perfect tool - Tumblr.",
    icon: "/images/cap-tumblr.webp",
    link: "/capabilities/tumblr-api-integration-services",
  },
  {
    id: 21,
    title: "CONCUR API",
    description:
      "Cloud-based business service to manage travel and expenses easily.",
    icon: "/images/cap-concur.webp",
    link: "/capabilities/concur-api-integration-services",
  },
  {
    id: 22,
    title: "FRESHDESK",
    description: "Render an exceptional customer support with Freshdesk.",
    icon: "/images/cap-freshdesk.webp",
    link: "/capabilities/freshdesk-api-integration-services",
  },
  {
    id: 23,
    title: "CPANEL",
    description:
      "Simplified server configuration, email, and website management.",
    icon: "/images/cap-cpanel.webp",
    link: "/capabilities/cpanel-web-hosting-services",
  },
  {
    id: 24,
    title: "GOOGLE AMP",
    description:
      "Have your site's content load quickly on mobiles & increase your revenue.",
    icon: "/images/cap-googleamp.webp",
    link: "/capabilities/google-amp-development-services",
  },
  {
    id: 25,
    title: "PAYUMONEY",
    description:
      "Use any payment method and get cashback & great discounts on offers.",
    icon: "/images/cap-payumoney.webp",
    link: "/capabilities/payumoney-integration-company",
  },
  {
    id: 26,
    title: "AUTHORIZE.NET",
    description:
      "Now accept payments from anywhere and anytime with Authorize.net.",
    icon: "/images/cap-a.webp",
    link: "/capabilities/authorize-net-integration-company",
  },
  {
    id: 27,
    title: "SOCKET.IO",
    description:
      "Enable real-time bidirectional event-based communication like chat.",
    icon: "/images/cap-socket.webp",
    link: "/capabilities/socket",
  },
  {
    id: 28,
    title: "CCAVENUE",
    description:
      "Real-time, multi-currency & multiple payment options online with CCAvenue.",
    icon: "/images/cap-ccavenues.webp",
    link: "/capabilities/ccavenue-integration-services",
  },
  {
    id: 29,
    title: "GOOGLE MAPS API",
    description: "Customize web & mobile apps with interactive maps.",
    icon: "/images/cap-google-map.webp",
    link: "/capabilities/google-maps-api-integration-company",
  },
  {
    id: 30,
    title: "DROPBOX",
    description: "Access your important files anywhere and anytime.",
    icon: "/images/cap-dropbox.webp",
    link: "/capabilities/dropbox-api-integration-company",
  },
  {
    id: 31,
    title: "REACT",
    description:
      "Potent JavaScript library for building impeccable user-interfaces.",
    icon: "/images/cap-react.webp",
    link: "/capabilities/reactjs-development-company",
  },
  {
    id: 32,
    title: "BOOTSTRAP",
    description:
      "Responsive and Mobile-first front end-framework for easy web development.",
    icon: "/images/cap-bootstrap.webp",
    link: "/capabilities/bootstrap-development-company",
  },
  {
    id: 33,
    title: "JQUERY",
    description:
      "Easy to use, cross browser friendly and search engine optimized.",
    icon: "/images/cap-jQuery.webp",
    link: "/capabilities/jquery-development-company",
  },
  {
    id: 34,
    title: "DATADOG",
    description: "Modern Log Management & Analytics.",
    icon: "https://img.site/p/40/40/6326ac/solid-box?label=D&label_color=dde6e8&label_font_size=24",
    link: "/capabilities/datadog-integration-company",
  },
  {
    id: 35,
    title: "LOGTAIL",
    description: "Log management reimagined.",
    icon: "https://img.site/p/40/40/9b18f2/solid-box?label=L&label_color=dde6e8&label_font_size=25",
    link: "/capabilities/logtail-integration-company",
  },
  {
    id: 36,
    title: "RAILWAY",
    description: "Bring your code, Railway will handle the rest.",
    icon: "https://img.site/p/40/40/146696/solid-box?label=R&label_color=fffafa&label_font_size=25",
    link: "/capabilities/railway-integration-company",
  },
  {
    id: 37,
    title: "DOPPLER",
    description: "The SecretOps Platform.",
    icon: "https://img.site/p/40/40/5973e7/solid-box?label=D&label_color=ededed&label_font_size=25",
    link: "/capabilities/doppler-integration-company",
  },
  {
    id: 38,
    title: "BITBUCKET",
    description: "Optimized for teams using Jira.",
    icon: "https://img.site/p/40/40/2962ff/solid-box?label=B&label_color=ffffff&label_font_size=25",
    link: "/capabilities/bitbucket-integration-company",
  },
  {
    id: 39,
    title: "GITLAB",
    description: "The One DevOps Platform.",
    icon: "https://img.site/p/40/40/fc6d26/solid-box?label=G&label_color=222F3D&label_font_size=25",
    link: "/capabilities/gitlab-integration-company",
  },
  {
    id: 40,
    title: "GITHUB",
    description:
      "The complete platform to build, scale, and deliver secure applications.",
    icon: "https://img.site/p/40/40/202124/solid-box?label=G&label_color=ffffff&label_font_size=25",
    link: "/capabilities/github-integration-company",
  },
  {
    id: 41,
    title: "CHECKLY",
    description: "Delightful Active Monitoring for Developers.",
    icon: "https://img.site/p/40/40/45c8f1/solid-box?label=C&label_color=ffffff&label_font_size=25",
    link: "/capabilities/checkly-integration-company",
  },
  {
    id: 42,
    title: "AXIOM",
    description: "Observability without limits.",
    icon: "https://img.site/p/40/40/000000/solid-box?label=A&label_color=ffffff&label_font_size=25",
    link: "/capabilities/axiom-integration-company",
  },
  {
    id: 43,
    title: "SLACK",
    description: "Great teamwork starts with a digital HQ.",
    icon: "https://img.site/p/40/40/541554/solid-box?label=S&label_color=ffffff&label_font_size=25",
    link: "/capabilities/slack-integration-company",
  },
  {
    id: 44,
    title: "CLEARK",
    description: "Drop-in authentication.",
    icon: "https://img.site/p/40/40/6c47ff/solid-box?label=C&label_color=ffffff&label_font_size=25",
    link: "/capabilities/cleark-integration-company",
  },
  {
    id: 45,
    title: "HASURA",
    description: "Instant GraphQL on all your data.",
    icon: "https://img.site/p/40/40/1eb4d4/solid-box?label=H&label_color=ffffff&label_font_size=25",
    link: "/capabilities/hasura-integration-company",
  },
  {
    id: 46,
    title: "DEBUGBEAR",
    description: "Monitor Site Speed and Core Web Vitals.",
    icon: "https://img.site/p/40/40/bb803a/solid-box?label=D&label_color=332a29&label_font_size=25",
    link: "/capabilities/debugbear-integration-company",
  },
  {
    id: 47,
    title: "DATOCMS",
    description:
      "The most feature-rich, user-friendly, and performant headless CMS.",
    icon: "https://img.site/p/40/40/ff593d/solid-box?label=D&label_color=ffffff&label_font_size=25",
    link: "/capabilities/datocms-integration-company",
  },
  {
    id: 48,
    title: "BUTTERCMS",
    description: "The headless CMS that you'll melt over.",
    icon: "https://img.site/p/40/40/151e46/solid-box?label=B&label_color=ffffff&label_font_size=25",
    link: "/capabilities/buttercms-integration-company",
  },
  {
    id: 49,
    title: "CONTENTFUL",
    description: "Get a head start with a modern content platform.",
    icon: "https://img.site/p/40/40/3ab2e6/solid-box?label=C&label_color=000000&label_font_size=25",
    link: "/capabilities/contentful-integration-company",
  },
  {
    id: 50,
    title: "BIGCOMMERCE",
    description: "E-Commerce for the New Era.",
    icon: "https://img.site/p/40/40/151e46/solid-box?label=B&label_color=ffffff&label_font_size=25",
    link: "/capabilities/bigcommerce-integration-company",
  },
  {
    id: 51,
    title: "AGILITYCMS",
    description: "A Headless CMS That Gives You the Best of Both Worlds.",
    icon: "https://img.site/p/40/40/ffcb29/solid-box?label=A&label_color=000000&label_font_size=25",
    link: "/capabilities/agilitycms-integration-company",
  },
  {
    id: 52,
    title: "MONGODBATLAS",
    description: "Easily develop and deploy multi-cloud applications.",
    icon: "https://img.site/p/40/40/116149/solid-box?label=M&label_color=ffffff&label_font_size=25",
    link: "/capabilities/mongodbatlas-integration-company",
  },
  {
    id: 53,
    title: "PLANETSCALE",
    description: "Database for creators.",
    icon: "https://img.site/p/40/40/000000/solid-box?label=P&label_color=ffffff&label_font_size=25",
    link: "/capabilities/planetscale-integration-company",
  },
  {
    id: 54,
    title: "SANITY",
    description: "Get a head start with a modern content platform.",
    icon: "https://img.site/p/40/40/f03e2f/solid-box?label=S&label_color=ffffff&label_font_size=25",
    link: "/capabilities/sanity-integration-company",
  },
  {
    id: 55,
    title: "SHOPIFY",
    description: "If you can dream it, you can sell it with Shopify.",
    icon: "https://img.site/p/40/40/008060/solid-box?label=S&label_color=ffffff&label_font_size=25",
    link: "/capabilities/shopify-development-company",
  },
  {
    id: 56,
    title: "SUPABASE",
    description: "Build in a weekend. Scale to millions.",
    icon: "https://img.site/p/40/40/34b27b/solid-box?label=S&label_color=ffffff&label_font_size=25",
    link: "/capabilities/supabase-development-company",
  },
  {
    id: 57,
    title: "SWELL",
    description:
      "The eCommerce platform to help you build, sell and scale your business.",
    icon: "https://img.site/p/40/40/1d0a43/solid-box?label=S&label_color=ffffff&label_font_size=25",
    link: "/capabilities/swell-development-company",
  },
  {
    id: 58,
    title: "TERRAFORM",
    description: "Automate Your Infrastructure on Any Cloud.",
    icon: "https://img.site/p/40/40/7b42bc/solid-box?label=T&label_color=ffffff&label_font_size=25",
    link: "/capabilities/terraform-integration-company",
  },
  {
    id: 59,
    title: "THINBACKEND",
    description: "Instant API for your Postgres DB.",
    icon: "https://img.site/p/40/40/2aa198/solid-box?label=T&label_color=ffffff&label_font_size=25",
    link: "/capabilities/thinbackend-integration-company",
  },
  {
    id: 60,
    title: "UPSTASH",
    description: "Serverless data for Redis and Kafka.",
    icon: "https://img.site/p/40/40/00c98d/solid-box?label=U&label_color=050505&label_font_size=25",
    link: "/capabilities/upstash-integration-company",
  },
  {
    id: 61,
    title: "FAUNA",
    description: "Build applications without limits.",
    icon: "https://img.site/p/40/40/604be9/solid-box?label=F&label_color=ffffff&label_font_size=25",
    link: "/capabilities/fauna-integration-company",
  },
  {
    id: 62,
    title: "FORMSPREE",
    description: "The form solution for any developer.",
    icon: "https://img.site/p/40/40/c70a23/solid-box?label=F&label_color=ffffff&label_font_size=25",
    link: "/capabilities/formspree-development-company",
  },
  {
    id: 63,
    title: "SENTRY",
    description: "Users and logs provide clues. Sentry provides answers.",
    icon: "https://img.site/p/40/40/151e46/solid-box?label=S&label_color=ffffff&label_font_size=25",
    link: "/capabilities/sentry-implementation-company",
  },
]);
// Pagination state
const currentPage = ref(1);
const itemsPerPage = 6;

// Computed properties
const visibleServices = computed(() => {
  return services.value.slice(0, currentPage.value * itemsPerPage);
});

const hasMoreServices = computed(() => {
  return visibleServices.value.length < services.value.length;
});

// Methods
const loadMore = () => {
  currentPage.value++;
};

const props = defineProps({
  title: {
    type: String,
    default: "Our Services",
  },
  description: {
    type: String,
  },
});
</script>

<template>
  <section class="relative z-20">
    <div class="max-w-screen-xl mx-auto pt-10 px-4">
      <h2 class="text-center mb-4">
        <WrGradientText append-class="text-3xl lg:text-[48px]">
          {{ title }}
        </WrGradientText>
      </h2>
      <p
        v-if="description"
        class="!leading-[1.8] text-lg text-[#6d6685] text-center mb-6"
      >
        {{ description }}
      </p>

      <!-- Cards Grid -->
      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-8">
        <WrCardService
          v-for="service in visibleServices"
          :key="service.id"
          :service="service"
        />
      </div>

      <!-- View More Button -->
      <div class="text-center" v-if="hasMoreServices">
        <button
          @click="loadMore"
          class="mx-auto size-14 rounded-full border-2 border-gray-400 flex justify-center items-center *:rounded-full"
          aria-label="Load more services"
          >
          <span class="size-1 bg-red-400 mr-1"></span>
          <span class="size-1 bg-yellow-400 mr-1"></span>
          <span class="size-1 bg-green-400"></span>
        </button>
      </div>
    </div>
  </section>
</template>
